<template>
  <bouncing-loader class="redefined-bouncer" />
</template>

<script>
  import BouncingLoader from './Bouncing-loader';
  export default {
    components: {
      BouncingLoader
    }
        
  }
</script>

<style>
  .redefined-bouncer {
    margin-right: 45rem !important;
  }
  .redefined-bouncer > div {
    width: 0.8rem !important;
    height: 0.8rem !important;
    margin-right: 25rem !important;
    margin: 0.2rem !important;
  }
</style>

